import React from "react";
import {CreateVisitorModalApp} from "../Functionality/CreateVisitorModalApp";
import CustomModal from "../../../../components/Modal/CustomModal";
import CreateVisitorForm from "./CreateVisitorForm";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const CreateVisitorModal = (props) => {

    const { title,
        onHide,
        setModified,
        setSelectedList,
        selectedList,
        dataVisitor,
        selectVisitorType=false,
        moduleId
    } = props;

    const {
        userData,
        disabled,
        handleChange,
        emptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDocumentId,
        handleCreate,
        handleClose,
        handleEmailChange,
        handlePhoneNumberChange,
        setUserData,
        clearButton,
        allVisitorTypes
    } = CreateVisitorModalApp({
        setModified,
        onHide,
        setSelectedList,
        selectedList,
        dataVisitor,
        selectVisitorType
    })


    return (
        <>
            <CustomModal {...props} size='lg'
                 onConfirm={handleCreate}
                 title={title}
                 rightTitleButton={clearButton}
                 onHide={handleClose}>

                <div className='row'>
                    <CreateVisitorForm
                        userData={userData}
                        setUserData={setUserData}
                        disabled={disabled}
                        handleChange={handleChange}
                        handleEmailChange={handleEmailChange}
                        handlePhoneNumberChange={handlePhoneNumberChange}
                        emptyFields={emptyFields}
                        isValidEmail={isValidEmail}
                        isValidPhoneNumber={isValidPhoneNumber}
                        isValidDocumentId={isValidDocumentId}
                        dataVisitor={dataVisitor}
                        allVisitorTypes={allVisitorTypes}
                        selectVisitorType={selectVisitorType || dataVisitor?.id || dataVisitor?.userId }
                        moduleId={moduleId}
                    />
                </div>
            </CustomModal>
        </>
    );
}

export default CreateVisitorModal
